import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "../../data/content";
import { useSettingValue } from "../../context/SiteConfig";

export function Footer() {
  const year = new Date().getFullYear();
  const email = useSettingValue("email", "info@meridianvanguardsolutions.com");
  const phone = useSettingValue("phone", "Coming Soon");
  const linkedin = useSettingValue("linkedin_url", "https://www.linkedin.com");
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="inline-flex bg-white rounded-md px-3 py-2">
              <img src="/logo.png" alt="Meridian Vanguard Solutions, LLC" className="h-11 w-auto" />
            </span>
            <p className="mt-6 text-sm uppercase tracking-[0.22em] text-accent2 font-semibold">
              Strategy &bull; Innovation &bull; Execution
            </p>
            <p className="mt-4 max-w-md text-white/70 leading-relaxed text-[15px]">
              A veteran-led small business delivering strategic procurement, ethical
              business practices, and mission-focused execution for the public sector.
            </p>
            <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-1.5 text-xs uppercase tracking-[0.18em] text-white/80">
              Veteran-Owned Small Business
            </span>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h3 className="font-heading text-sm uppercase tracking-[0.18em] text-white/60 mb-5">Navigate</h3>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/75 hover:text-white transition-colors text-[15px]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm uppercase tracking-[0.18em] text-white/60 mb-5">Connect</h3>
            <a
              href={`mailto:${email}`}
              data-testid="footer-email"
              className="block text-white/75 hover:text-white transition-colors text-[15px] break-words"
            >
              {email}
            </a>
            <p className="mt-3 text-white/60 text-[15px]">Phone: {phone}</p>
            <p className="mt-1 text-white/60 text-[15px]">Mon–Fri, 8:00 AM–5:00 PM</p>
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="mt-6 inline-flex items-center gap-2 rounded-xl border border-white/20 px-4 py-2.5 text-sm font-semibold hover:bg-white hover:text-navy transition-colors"
            >
              <Linkedin size={18} /> LinkedIn <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/55 text-sm text-center md:text-left">
            © {year} Meridian Vanguard Solutions, LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/55 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <span className="text-white/30">|</span>
            <Link to="/contact" className="text-white/55 hover:text-white text-sm transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
